import "./third.css";
import D from "../img/dakshinkali.png";
import H from "../img/hosty.png";
import A from "../img/architecture.png";
import N from "../img/nepolive.png";

import React from "react";
import { Helmet } from "react-helmet-async";

const Third = () => {
  return (
    <section className="t" id="recent-cases">
      <Helmet>
        <title>
          Recent Cases - Bichitras Portfolio | Software Development & 3D
          Modeling Projects
        </title>
        <meta
          name="description"
          content="Explore our recent projects including NepoLive streaming platform, 3D architectural modeling, Niwasly hosting services, and Dakshinkali ecommerce solutions."
        />
        <meta
          name="keywords"
          content="software development portfolio, 3D modeling projects, live streaming platform, hosting services, ecommerce development, architectural visualization"
        />
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Recent Projects Portfolio",
          "description": "Recent software development and 3D modeling projects by Bichitras Engineering Studio",
          "itemListElement": [
            {
              "@type": "CreativeWork",
              "position": 1,
              "name": "NepoLive",
              "description": "Live streaming platform for content creators",
              "creator": {
                "@type": "Organization",
                "name": "Bichitras"
              },
              "about": "Live streaming platform"
            },
            {
              "@type": "CreativeWork",
              "position": 2,
              "name": "3D & Architectures",
              "description": "3D Modelling & Architecture by Bichitras Builds",
              "creator": {
                "@type": "Organization",
                "name": "Bichitras"
              },
              "about": "3D modeling and architectural visualization"
            },
            {
              "@type": "CreativeWork",
              "position": 3,
              "name": "Niwasly",
              "description": "Complete platform that provides hosting services",
              "creator": {
                "@type": "Organization",
                "name": "Bichitras"
              },
              "about": "Hosting services platform"
            },
            {
              "@type": "CreativeWork",
              "position": 4,
              "name": "Dakshinkali",
              "description": "A ecommerce website relaunch that goes deeper",
              "creator": {
                "@type": "Organization",
                "name": "Bichitras"
              },
              "about": "Ecommerce website development"
            }
          ]
        }`}
        </script>
      </Helmet>
      <h2 className="rec">
        Recent <span className="break">Cases</span>
      </h2>
      <article className="rec-1">
        <h1 className="title-1">NepoLive</h1>
        <p className="des-1">Live streaming platform for content creators</p>
        <div className="sub-rec-1">
          <img
            src={N}
            alt="NepoLive streaming platform interface showing content creator dashboard"
            className="picdrop"
          />
        </div>
      </article>
      <article className="rec-2">
        <h1 className="title-1">3D & Architectures</h1>
        <p className="des-1">3d Modelling & Architecture by Bichitras Builds</p>
        <div className="sub-rec-1">
          <img
            src={A}
            alt="3D architectural visualization showing modern building design"
            className="picdrop"
          />
        </div>
      </article>
      <article className="rec-3">
        <h1 className="title-1">Niwasly</h1>
        <p className="des-1">
          Complete platform that provides hosting services
        </p>
        <div className="sub-rec-1">
          <img
            src={H}
            alt="Niwasly hosting platform dashboard showing server management interface"
            className="picdrop"
          />
        </div>
      </article>
      <article className="rec-4">
        <h1 className="title-1">Dakshinkali</h1>
        <p className="des-1">A ecommerce website relaunch that goes deeper</p>
        <div className="sub-rec-1">
          <img
            src={D}
            alt="Dakshinkali ecommerce website showing product catalog and shopping interface"
            className="picdrop"
          />
        </div>
      </article>
      <div className="oval-2">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets2.lottiefiles.com/packages/lf20_avndu8kw.json"
          aria-label="Animated design element"
        ></lottie-player>
      </div>
    </section>
  );
};
// force push for vercel CI/CD 2
export default Third;
